"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var rows_change_event_1 = require("../model/event/rows-change-event");
var rows_change_event_type_1 = require("../model/event/rows-change-event-type");
var report_table_view_model_1 = require("../model/report-table-view.model");
var row_option_1 = require("../model/row-option");
var row_view_model_1 = require("../model/row-view.model");
var table_row_type_1 = require("../model/table-row-type");
var dataset_container_1 = require("../service/dataset-container");
var view_event_service_1 = require("../service/view-event.service");
var row_type_1 = require("./model/row-type");
var rowview_drag_and_drop_manager_1 = require("./service/rowview-drag-and-drop-manager");
var SisTabularReportRowsPanelComponent = /** @class */ (function () {
    function SisTabularReportRowsPanelComponent(applicationPropertiesService, datasetContainer, viewEventService) {
        var _this = this;
        this.applicationPropertiesService = applicationPropertiesService;
        this.datasetContainer = datasetContainer;
        this.viewEventService = viewEventService;
        this._groupedPathItems = new Map();
        this._columnsDepth = 1;
        this._subscriptions = [];
        this._dndManager = new rowview_drag_and_drop_manager_1.RowViewDragAndDropManager(function () { return _this.reportTableView.rows; }, this.viewEventService);
    }
    SisTabularReportRowsPanelComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.dataSetId) {
            this._subscriptions.push(this.datasetContainer.getGroupedCategoryPaths(this.dataSetId).subscribe(function (paths) {
                _this._groupedPathItems = paths;
                _this._allPaths = new Map();
                Array.from(paths.values()).forEach(function (groupPaths) {
                    groupPaths.forEach(function (path) { return _this._allPaths.set(path.id, path); });
                });
            }));
            this._subscriptions.push(this.viewEventService.columnsChange$.subscribe(function (event) { return _this.onColumnsChange(event); }));
            this._subscriptions.push(this.viewEventService.columnHighlight$.subscribe(function (event) { return _this.onColumnHighlight(event); }));
            this._subscriptions.push(this.viewEventService.columnElementSelected$.subscribe(function (data) {
                _this.reportTableView.rows.cleanSelectedFlags();
                _this.reportTableView.rows.cleanGoingToReplaceFlags();
            }));
            this._subscriptions.push(this.viewEventService.rowElementSelected$.subscribe(function (data) {
                if (!data.rowView) {
                    _this.reportTableView.rows.cleanSelectedFlags();
                    _this.reportTableView.rows.cleanGoingToReplaceFlags();
                }
            }));
        }
    };
    SisTabularReportRowsPanelComponent.prototype.ngOnChanges = function (changes) {
    };
    SisTabularReportRowsPanelComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
        this._dndManager.destroy();
    };
    Object.defineProperty(SisTabularReportRowsPanelComponent.prototype, "groupedPathItems", {
        get: function () {
            return this._groupedPathItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportRowsPanelComponent.prototype, "dndManager", {
        get: function () {
            return this._dndManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportRowsPanelComponent.prototype, "columnsDepth", {
        get: function () {
            return this._columnsDepth;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds row in root
     */
    SisTabularReportRowsPanelComponent.prototype.add = function (change) {
        // clean removed element
        this.reportTableView.rows.cleanRemovedElements();
        var categoryPathHolderId = change.value;
        var rowView = new row_view_model_1.RowView(new idm_reporting_service_client_js_1.RowCategoryBuilder(categoryPathHolderId).getElement());
        rowView.rowType = row_type_1.RowType.SPECIFIED;
        this.reportTableView.rows.add(rowView);
        // recalculate indexes
        this.reportTableView.rows.setIndexes();
        // setting indexes for just created row to put appropriate classes in view
        this.reportTableView.rows.setCreatedRowIndexes(rowView.index);
        this.reportTableView.rows.cleanNewRowIndexes();
        // send event to add created row in table view
        var index = this.reportTableView.rows.rowsCount - 1;
        var prevIndex = this.reportTableView.rows.findPreviousVisibleElementIndex(this.reportTableView.rows.rowsCount - 1);
        var options = this.reportTableView.rows.getCollapsedExpandedOptions()
            .add(this.reportTableView.rows.rowsCount - 1, new row_option_1.RowOption(table_row_type_1.TableRowType.CREATED, true))
            .add(prevIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.BEFORE_CREATED, true))
            .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_CREATED, options));
    };
    SisTabularReportRowsPanelComponent.prototype.openSelectionMenu = function () {
        if (this.selectMenu) {
            this.reportTableView.rows.cleanSelectedFlags();
            this.reportTableView.rows.cleanGoingToReplaceFlags();
            this.viewEventService.resetElementSelection();
            this.selectMenu.open();
        }
        else {
            this.showNew();
        }
    };
    SisTabularReportRowsPanelComponent.prototype.onSelectionPanelClose = function () {
        this.hideNew();
    };
    SisTabularReportRowsPanelComponent.prototype.showNew = function () {
        this.reportTableView.rows.showNew = true;
        // send event to highlight current row in table view
        var options = this.reportTableView.rows.getCollapsedExpandedOptions()
            .add(this.reportTableView.rows.rowsCount, new row_option_1.RowOption(table_row_type_1.TableRowType.HIGHLIGHTED, true))
            .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_HIGHLIGHTED, options));
    };
    SisTabularReportRowsPanelComponent.prototype.hideNew = function () {
        if (this.selectMenu && !this.selectMenu.isPanelOpen()) {
            this.reportTableView.rows.showNew = false;
            // send event to deactivate active row in table view
            var tableOptions = this.reportTableView.rows.getCollapsedExpandedOptions()
                .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_UNHIGHLIGHTED, tableOptions));
        }
    };
    SisTabularReportRowsPanelComponent.prototype.onColumnsChange = function (event) {
        this._columnsDepth = event.columnsDepth;
    };
    SisTabularReportRowsPanelComponent.prototype.onColumnHighlight = function (event) {
        if (event.newActivated) {
            this.reportTableView.rows.cleanCreatedRowIndexes();
        }
    };
    SisTabularReportRowsPanelComponent.prototype.onHeaderClick = function () {
        this.reportTableView.rows.cleanSelectedFlags();
        this.reportTableView.rows.cleanGoingToReplaceFlags();
        this.viewEventService.resetElementSelection();
    };
    SisTabularReportRowsPanelComponent.prototype.isRowAfterNew = function (index) {
        return index === this.reportTableView.rows.afterNewRowIndex;
    };
    SisTabularReportRowsPanelComponent.prototype.isRowAfterCreated = function (index) {
        return index === this.reportTableView.rows.afterCreatedRowIndex;
    };
    SisTabularReportRowsPanelComponent.prototype.isRowSelected = function () {
        return !!(this.selectMenu && this.selectMenu.isPanelOpen());
    };
    __decorate([
        core_1.ViewChild('rowRootSelectMenu'),
        __metadata("design:type", idm_ng_controls_1.SisSelectComponent)
    ], SisTabularReportRowsPanelComponent.prototype, "selectMenu", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", report_table_view_model_1.ReportTableView)
    ], SisTabularReportRowsPanelComponent.prototype, "reportTableView", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisTabularReportRowsPanelComponent.prototype, "dataSetId", void 0);
    SisTabularReportRowsPanelComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-tabular-report-rows-panel',
            template: require('./sis-tabular-report-rows-panel.component.html'),
            styles: [require('./sis-tabular-report-rows-panel.component.css')],
            encapsulation: core_1.ViewEncapsulation.None,
            changeDetection: core_1.ChangeDetectionStrategy.Default
        }),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            dataset_container_1.DatasetContainer,
            view_event_service_1.ViewEventService])
    ], SisTabularReportRowsPanelComponent);
    return SisTabularReportRowsPanelComponent;
}());
exports.SisTabularReportRowsPanelComponent = SisTabularReportRowsPanelComponent;
//# sourceMappingURL=sis-tabular-report-rows-panel.component.js.map